import mange from './mange.js'
const constants = {
	...mange
}
let result = {}
for (let [key, value] of Object.entries(constants)) {
	result[key] = `${value}`
}
export default result
